module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Tq0glo/tc-custom/9781504067263.jpg?1698088551949",
      "alt": "This image is the cover for the book American Way"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("American Way\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("An enlightening selection of writings by the US president who defined the American way as he led the country through the twentieth century’s darkest days.")])]), _c('p', [_vm._v("As the thirty-second president of the United States, Franklin Delano Roosevelt navigated the country out of the Great Depression through an extraordinary agenda of public works and financial reforms known as the New Deal. He then inspired the American people to stand up to tyranny by speaking out against fascist regimes abroad during the Second World War.")]), _vm._v(" These were defining moments for America, and Roosevelt brilliantly articulated their significance in a series of speeches and other public addresses. "), _c('i', [_vm._v("The American Way ")]), _vm._v("presents a selection of his historic writings, which established the ideological foundations of contemporary American democracy.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Franklin D Roosevelt, Dagobert D. Runes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Franklin Delano Roosevelt, often referred to by his initials FDR, was an American politician who served as the thirty-second president of the United States from 1933 until his death in 1945.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Philosophical Library/Open Road\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0